import { matchingUsers } from '../utils/messaging/user';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactListItem from './contact-list-item.gjs';

export default class ConversationMemberListItem extends Component {
  @service intl;
  @service messaging;

  get member() {
    return this.args.member;
  }

  get contact() {
    if (this.member.isCouple) {
      return {
        id: this.member.id,
        members: this.member.members,
        isClient: true,
      };
    }

    return {
      id: this.member.id,
      members: [this.member],
      isClient: this.member.isClient,
    };
  }

  get profileMember() {
    return this.member.isCouple ? this.member.members?.[0] : this.member;
  }

  get isCurrentUser() {
    return matchingUsers(this.profileMember, this.messaging.currentProfile.user);
  }

  get nameSuffix() {
    if (this.member.isCouple) return '';
    return this.isCurrentUser ? this.intl.t('emc.conversation_details.you') : '';
  }

  get showAwayIndicator() {
    if (!this.messaging.currentProfile.isClient) {
      return false;
    }

    return this.profileMember?.isAway === true && this.profileMember?.isClinician;
  }

  get showScopeIndicator() {
    return this.messaging.currentProfile.isClinician && this.profileMember?.isClient;
  }

  <template>
    <ContactListItem
      @contact={{this.contact}}
      @nameSuffix={{this.nameSuffix}}
      @onNameClick={{@onNameClick}}
      @showAwayIndicator={{this.showAwayIndicator}}
      @showScopeIndicator={{this.showScopeIndicator}}
      data-test-conversation-member-list-item
    />
  </template>
}
